
import {login,get_user} from '@/api/user.api'
const state={
    info:undefined,
    token:null        // access-token
};

const mutations={

}

const actions = {
    login : async ({state},model)=>{
        let data = await login(model);
        state.token = data.id;
        // cookie.set('token',state.token); 
        // cookie.set('uid',data.userId);
    },

    get_info:async ({state},id)=>{
        let user = await get_user(id);
        console.log(user);
        state.info = user;
    },
    
    logoff:({state})=>{
        cookie.clear();
        state.token = null;
        state.info =null;
    }
}

const getters = {
    info:state=>state.info,
    token: state => cookie.get('token') || state.token
}

export default {
    namespaced:true,
    state, mutations, actions, getters
}